import {Loader} from '@googlemaps/js-api-loader';
import switchStep from '../components/switchStep';
import {history} from '../globals/config';
import {getCalendarFromWacs} from './dateSelector';
import {apSwitchStep} from '../../appointment-tool/components/apSwitchStep';
import toolLoader from '../../appointment-tool/components/toolLoader';
import {garageInfoModal} from '../../appointment-tool/modules/vehicleSelector';
import apAnalytics, {setApGarageLocatorDataRef} from '../../appointment-tool/components/apAnalytics';
import qtAnalytics, {setGarageLocatorDataRef} from '../components/qtAnalytics';

const $ = jQuery;
const $quoteToolContainer = $('#quote-tool');
const $appointmentToolContainer = $('#appointment-tool');

/**
 * Garage selector data
 * @type {{garageID: string, name: string, address: string, phone: string, workingHours: [], open: boolean, departmentID: string}}
 */
export let garageLocatorData = {
    garageID: '',
    name: '',
    address: '',
    phone: '',
    workingHours: [],
    open: false,
    departmentID: '',
};

// Register reference for analytics dealer enrichment (avoids circular dependency)
setGarageLocatorDataRef(garageLocatorData);
setApGarageLocatorDataRef(garageLocatorData);

export default function () {
    var garageLocatorAtrack = analyticstracker();
    var bodyShopSearchDone = false;
    var mapStyles = [
        {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#444444',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [
                {
                    color: '#f2f2f2',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi.business',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'all',
            stylers: [
                {
                    saturation: -100,
                },
                {
                    lightness: 45,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'all',
            stylers: [
                {
                    color: '#b4d4e1',
                },
                {
                    visibility: 'on',
                },
            ],
        },
    ];

    const loader = new Loader({
        apiKey: menaObject.mapKey,
        libraries: ['places'],
    });

    if ($('.garage-locator').length > 0) {

		loader.importLibrary('maps').then(() => {
			let calculateDistance = false;

			function recalculateLocationsHeight() {
				let item1Height = $('.garage-locator__item:nth-child(1').outerHeight();
				let item2Height = $('.garage-locator__item:nth-child(2').outerHeight();
				let item3Height = $('.garage-locator__item:nth-child(3').outerHeight();

				let listHeight = item1Height + item2Height + item3Height/2 + 28 + 'px';
				$('.garage-locator__locations-wrap').css('height', listHeight);
			}

			window.addEventListener('load', recalculateLocationsHeight);

			var rad = function (x) {
				return (x * Math.PI) / 180;
			};

			var getDistance = function (p1, p2) {
				var R = 6378137; // Earth’s mean radius in meter
				var dLat = rad(p2.lat - p1.lat);
				var dLong = rad(p2.lng - p1.lng);
				var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
				var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				var d = R * c;
				return d / 1000; // returns the distance in km
			};

			function prepareData(placeLocation) {
				let locationsData = [];
				let position, shopLat, shopLng, shopId;

				$('.garage-locator__item:not(.hide)').each(function () {
					let $this = $(this);

					if ($this.data('lat') && $this.data('lng')) {
						position = {
							lat: parseFloat($this.data('lat')),
							lng: parseFloat($this.data('lng')),
						};
						shopId = $this.attr('id');
						let is_open = true;
						locationsData.push({ position, is_open, shopId });
					}
				});

				// Check if data-lang and data-lat exists on .garage-locator__map-el block and use it as center
				if ($('.garage-locator__map-el').data('lat') && $('.garage-locator__map-el').data('lang')) {
					placeLocation = {
						lat: $('.garage-locator__map-el').data('lat'),
						lng: $('.garage-locator__map-el').data('lang'),
					};

					calculateDistance = true;
				}

				initMap(locationsData, placeLocation, calculateDistance);
			}

			function initMap(locationsData, placeLocation) {
				function handleLocationError(err) {
					console.error(`ERROR(${err.code}): ${err.message}`);
				}

				loadjs(['https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js'], function () {
					//var markers = [];
					var bounds = new google.maps.LatLngBounds();
					let language = $('html').attr('lang');
					let languageShort = 'en';
					if (language) {
						let languageShort = language.substring(0, 2);
					}
					var map = new google.maps.Map(document.querySelector('.garage-locator__map-el'), {
						zoom: 5,
						center: placeLocation,
						styles: mapStyles,
						disableDefaultUI: true,
						zoomControl: true,
						language: languageShort,
					});

					// If class .appointment-tool exists pin should be blue

					const markers = locationsData.map((location, i) => {
						bounds.extend(location.position);
						let icon = menaObject.pinRed;
						if ($('.appointment-tool').length > 0) {
							icon = menaObject.pinBlue;
						}

						return new google.maps.Marker({
							position: location.position,
							icon: icon,
							shopId: location.shopId,
						});
					});

					if (placeLocation.lat > 0 && placeLocation.lng > 0) {
						bounds.extend(placeLocation);
						const marker = new google.maps.Marker({
							map: map,
							icon: menaObject.pinCenter,
							position: placeLocation,
						});
					}

					var markerCluster = new MarkerClusterer(map, markers, {
						imagePath: menaObject.cluster,
						styles: [
							{
								textColor: '#fff',
								url: menaObject.cluster,
								width: 50,
								height: 50,
								textSize: 14,
								anchorText: [15.5, 0],
							},
						],
					});

					if (calculateDistance) {
						let activeStores = [];
						let hasStoreInFirstRadius = false;
						$('.garage-locator__item').each(function () {
							let $this = $(this);
							let storeDistance = Math.round(
								getDistance(placeLocation, {
									lat: parseFloat($this.data('lat')),
									lng: parseFloat($this.data('lng')),
								})
							);
							$this.removeClass('hide');
							let hasStoreInFirstRadius = true;
							let storeData = {
								id: $this.attr('id'),
								distance: storeDistance,
							};
							activeStores.push(storeData);
						});

						if (!hasStoreInFirstRadius) {
							$('.garage-locator__item').each(function () {
								let $this = $(this);
								let storeDistance = Math.round(
									getDistance(placeLocation, {
										lat: parseFloat($this.data('lat')),
										lng: parseFloat($this.data('lng')),
									})
								);
								$this.removeClass('hide');
								hasStoreInFirstRadius = true;
								let storeData = {
									id: $this.attr('id'),
									distance: storeDistance,
								};
								activeStores.push(storeData);
							});
						}

						if (activeStores.length > 0) {
							activeStores.sort(function (a, b) {
								return a.distance - b.distance;
							});

							activeStores.forEach((item) => {
								$('#' + item.id).css('order', item.distance);
							});
						} else {
							console.log('No stores found in the area');
						}
					}

					var markerFunc = markers.map((marker) => {
						google.maps.event.addListener(marker, 'mouseover', function () {
							if ($('.appointment-tool').length > 0) {
								marker.setIcon(menaObject.pinDarkBlue);
							} else {
								marker.setIcon(menaObject.pinDark);
							}
						});
						google.maps.event.addListener(marker, 'click', function () {

							// Add pinRed to other markers
							markers.forEach((marker) => {
								if ($('.appointment-tool').length > 0) {
									marker.setIcon(menaObject.pinBlue);
								} else {
									marker.setIcon(menaObject.pinRed);
								}
							});
							if ($('.appointment-tool').length > 0) {
								marker.setIcon(menaObject.pinDarkBlue);
							} else {
								marker.setIcon(menaObject.pinDark);
							}
						});
						google.maps.event.addListener(marker, 'mouseout', function () {
							if ($('.appointment-tool').length > 0) {
								marker.setIcon(menaObject.pinBlue);
							} else {
								marker.setIcon(menaObject.pinRed);
							}
						});

						google.maps.event.addListener(marker, 'click', function () {
							let shopId = marker.get('shopId');

							let innerWidth = window.innerWidth;

							var elementTop = document.querySelector('.garage-locator__locations-wrap').offsetTop;
							var divTop = document.querySelector('#' + shopId).offsetTop;
							var elementRelativeTop = divTop - elementTop;

							$('.garage-locator__item.active').removeClass('active');
							$('#' + shopId).addClass('active');
							$('.js-qt-garage-locator-submit').removeClass('c-button--disabled');

							if (innerWidth >= 1024) {
								document.querySelector('.garage-locator__locations-wrap').scroll({
									top: elementRelativeTop,
									left: 0,
									behavior: 'smooth',
								});
							}
						});
					});

					let infoWindow = new google.maps.InfoWindow();
					const locationButton = document.querySelector('.garage-locator--block .js-locate-me');

					const options = {
						componentRestrictions: { country: 'be' },
						fields: ['address_components', 'geometry'],
					};

					if ($('.garage-locator__search input').length > 0) {
						let searchBoxInput = document.querySelector('.garage-locator__search input');
						const searchBox = new google.maps.places.Autocomplete(searchBoxInput, options);

						// Listen for input changes
						searchBoxInput.addEventListener('input', () => {
							if (!searchBoxInput.value.trim()) {
								// Refresh the page
								location.reload();
							}
						});

						var selectFirstOnEnter = function (input) {
							// store the original event binding function
							var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

							function addEventListenerWrapper(type, listener) {
								// Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected, and then trigger the original listener.
								if (type == 'keydown') {
									var orig_listener = listener;
									listener = function (event) {
										var suggestion_selected = $('.pac-item-selected').length > 0;
										if (event.which == 13 && !suggestion_selected) {
											var simulated_downarrow = $.Event('keydown', { keyCode: 40, which: 40 });
											orig_listener.apply(input, [simulated_downarrow]);
										}
										orig_listener.apply(input, [event]);
									};
								}
								_addEventListener.apply(input, [type, listener]); // add the modified listener
							}

							if (input.addEventListener) {
								input.addEventListener = addEventListenerWrapper;
							} else if (input.attachEvent) {
								input.attachEvent = addEventListenerWrapper;
							}
						};

						selectFirstOnEnter(searchBoxInput);

						map.addListener('bounds_changed', () => {
							searchBox.setBounds(map.getBounds());
						});

						google.maps.event.addDomListener(searchBox, 'keydown', function (event) {
							if (event.keyCode === 13) {
								event.preventDefault();
							}
						});

						searchBox.addListener('place_changed', () => {
							const place = searchBox.getPlace();
							let activeStores = [];
							let storeData;
							let hasStoreInFirstRadius = false;
							if (place.length == 0) {
								return;
							}

							if (!place.geometry || !place.geometry.location) {
								return;
							}

							let markersInAreaCount = 0;

							let placeLocation = {
								lat: place.geometry.location.lat(),
								lng: place.geometry.location.lng(),
							};

							$('.garage-locator__item').each(function () {
								let $this = $(this);
								let lat = parseFloat($this.data('lat'));
								let lng = parseFloat($this.data('lng'));
								let storeDistance = Math.round(
									getDistance(placeLocation, {
										lat: lat,
										lng: lng,
									})
								);
								//shopId = $this.attr('id');
								// Hide if distance is NaN, false, or exceeds max distance
								if (isNaN(storeDistance) || !storeDistance || storeDistance > menaObject.zipCodeDistance) {
									$this.addClass('hide');
								} else {
									$this.removeClass('hide');
									markersInAreaCount++;
									hasStoreInFirstRadius = true;
									// Add storeDistance to data attribute data-distance
									$this.attr('data-distance', storeDistance);

									let storeData = {
										id: $this.attr('id'),
										distance: storeDistance,
									};

									activeStores.push(storeData);
								}
							});

							if (!hasStoreInFirstRadius) {
								$('.garage-locator__item').each(function () {
									let $this = $(this);
									let storeDistance = Math.round(
										getDistance(placeLocation, {
											lat: parseFloat($this.data('lat')),
											lng: parseFloat($this.data('lng')),
										})
									);
									//shopId = $this.attr('id');
									if (storeDistance > menaObject.zipCodeDistanceAlternate) {
										$this.addClass('hide');
									} else {
										$this.removeClass('hide');
										markersInAreaCount++;
										hasStoreInFirstRadius = true;

										let storeData = {
											id: $this.attr('id'),
											distance: storeDistance,
										};

										activeStores.push(storeData);
									}
								});
							}

							if (activeStores.length > 0) {
								activeStores.sort(function (a, b) {
									return a.distance - b.distance;
								});

								activeStores.forEach((item, index) => {
									$('#' + item.id)
										.css('order', item.distance)
										.attr('data-position', index + 1);
								});
							} else {
								console.warn('No stores found in the area');
							}

							prepareData(placeLocation);
							let placeAddress = place.address_components[0].long_name + ' ' + place.address_components[1].long_name;
							let labelTitle = menaObject.searchResultsLabel;
							$('.garage-locator__title').html(`${labelTitle} <strong> ${placeAddress} </strong>`);

							/**
							 * Body shop search tracking
							 */
							let bodyShopCount = $('.garage-locator__locations .garage-locator__item:not(.hide)').length;
							let bodyShopSearchQuery = $('.garage-locator__search input[type="text"]').prop('value');

							let trackingEvent = {
								event: 'search-query',
								info: {
									searchType: 'filter',
									searchKeyword: String(bodyShopSearchQuery),
									searchResult: '',
									searchResultPosition: '',
									searchResultCount: String(bodyShopCount),
								},
							};

							garageLocatorAtrack.trackEvent(trackingEvent);
							bodyShopSearchDone = true;
						});
					}
					if ($('.garage-locator--block .js-locate-me').length > 0) {
						function locateMe(position) {
							const pos = {
								lat: position.coords.latitude,
								lng: position.coords.longitude,
							};

							let activeStores = [];
							let storeData;

							let markersInAreaCount = 0;

							$('.garage-locator__item').each(function () {
								let $this = $(this);
								let storeDistance = getDistance(pos, {
									lat: parseFloat($this.data('lat')),
									lng: parseFloat($this.data('lng')),
								});
								let storeDistanceRounded = Math.round(storeDistance);
								if (storeDistance <= menaObject.locateMeDistance) {
									$this.removeClass('hide');
									markersInAreaCount++;

									let storeData = {
										id: $this.attr('id'),
										distance: storeDistanceRounded,
									};

									activeStores.push(storeData);
								} else {
									$this.addClass('hide');
								}
							});

							if (markersInAreaCount == 0) {
								alert(menaObject.noResultsLabel);
							} else {
								prepareData(pos);
								let locationTitle = $('.garage-locator__title').data('locationTitle');
								$('.garage-locator__title').html(locationTitle);
								activeStores.sort(function (a, b) {
									return a.distance - b.distance;
								});

								if (activeStores.length > 0) {
									activeStores.forEach((item) => {
										$('#' + item.id).css('order', item.distance);
									});
								}
							}
							let label = $('.garage-locator__label').data('closeLocation');
							$('.garage-locator__label').html(`<strong>${markersInAreaCount}</strong> ${label} `);
						}

						locationButton.addEventListener('click', () => {
							// Try HTML5 geolocation.
							if (navigator.geolocation) {
								navigator.geolocation.getCurrentPosition(locateMe, handleLocationError);
							} else {
								// Browser doesn't support Geolocation
								handleLocationError(false, infoWindow, map.getCenter());
							}
						});
					}

					map.fitBounds(bounds);

					// Controll max zoom in case there's a single marker
					var initial = true;
					google.maps.event.addListener(map, 'zoom_changed', function () {
						if (initial) {
							if (map.getZoom() > 11) {
								map.setZoom(11);
								initial = false;
							}
						}
					});
				});
			}

			prepareData({ lat: 0, lng: 0 });
		});

        // Check URL and get g parameter and console log it
        const urlParams = new URLSearchParams(window.location.search);
        const garageSlug = urlParams.get('g');

		$('.garage-locator__item').on('click', function () {
			$('.garage-locator__item.active').removeClass('active');
			$(this).addClass('active');
			let selectGarage = document.querySelector('.js-qt-garage-locator-submit');
            // If there is g parameter in URL, dont scoll to button
            if (!garageSlug) {
                selectGarage.scrollIntoView({ block: 'center' });
            }
			$(selectGarage).removeClass('c-button--disabled');
		});

		if (garageSlug) {
			let garage = document.querySelector(`.garage-locator__item[data-garage="${garageSlug}"]`);

            if(garage) {
                garage.click();

                let submitGarage = document.querySelector('.js-qt-garage-locator-submit');

                if(submitGarage) {
                   const delayDuration = 2000;

					// Add delay and then click
					setTimeout(() => {
						submitGarage.click();
                        $('.garage-locator').addClass('loaded');
					}, delayDuration);
                }
            } else {
                $('.garage-locator').addClass('loaded');
            }
		} else {
            $('.garage-locator').addClass('loaded');
        }
	}

    // Submit
    $quoteToolContainer.on('click', '.js-qt-garage-locator-submit', function () {
        submitData();
        qtChangeStep();
    });
    $appointmentToolContainer.on('click', '.js-qt-garage-locator-submit', function () {
        submitData();
        apChangeStep();
    });

    function submitData() {
        let selectedGarage = document.querySelector('.garage-locator__item.active');

        if (selectedGarage) {
            let address = selectedGarage.querySelector('.garage-locator__address-value').innerHTML;
            // clear \t \n \r
            address = address.replace(/[\t\n\r]/gm, '');

            let name = selectedGarage.querySelector('.garage-locator__item-title').innerHTML;
            // clear \t \n \r
            name = name.replace(/[\t\n\r]/gm, '');

            let workingHours = selectedGarage.dataset.workingHours;

            if (workingHours) {
                workingHours = JSON.parse(workingHours);
            }

            let phone = selectedGarage.querySelector('.garage-locator__phone span').innerHTML;
            // clear \t \n \r
            phone = phone.replace(/[\t\n\r]/gm, '');

            let openStatus = document.querySelector('.garage-locator__item.active .garage-locator__item-status-label');
            if (openStatus.classList.contains('open')) {
                openStatus = true;
            } else {
                openStatus = false;
            }

            let departmentID = selectedGarage.dataset.departmentId;

            // Id is data-id attribute
            garageLocatorData.garageID = selectedGarage.dataset.id;
            // get content from selected garage
            garageLocatorData.name = name;
            garageLocatorData.address = address;
            garageLocatorData.phone = phone;
            garageLocatorData.workingHours = workingHours;
            garageLocatorData.open = openStatus;
            garageLocatorData.departmentID = departmentID;
        }
    }

    function qtChangeStep() {
        // Check previous page name
        if ((history[history.length - 2]) === "reports") {
            qtAnalytics('dealer-submit', garageLocatorData.name);
            history.push('contact');
            switchStep('contact');
            qtAnalytics('quote-contact');
        } else if ((history[history.length - 2]) === "vehicle") {
            qtAnalytics('dealer-submit', garageLocatorData.name, 4.1);
            history.push('schedule');
            getCalendarFromWacs();
            garageInfoModal('vehicle-select-contact-modal');
            switchStep('schedule');
        } else {
            qtAnalytics('dealer-submit', garageLocatorData.name);
            history.push('contact');
            switchStep('contact');
			qtAnalytics('quote-contact');
        }
    }

    function apChangeStep() {
        toolLoader();
        apSwitchStep('date-picker');
        apAnalytics('choose-dealer--submit', garageLocatorData.name);
    }
}
